import React from "react";
import { shop as shopRepository } from "@/repositories/shop";
import { ContainerList } from "@/components/Common/ContainerList";
import { GoListConfigProps } from "./types";

export const GoListConfig: React.FC<GoListConfigProps> = ({
  shopId,
  shopInfo,
  completeContainers,
  containers,
}) => {
  const handleCheckboxChange = async (containerId: string) => {
    if (!shopId || !shopInfo) return;

    const newCompleteContainers = completeContainers.includes(containerId)
      ? completeContainers.filter((id) => id !== containerId)
      : [...completeContainers, containerId];

    const currentCardConfig = shopInfo.cardConfig ?? {
      cardContents: {
        primaryField: "",
        secondaryField: "",
        tertiaryField: "",
      },
    };

    await shopRepository.update(shopId, {
      cardConfig: {
        ...currentCardConfig,
        goListCompleteContainers: newCompleteContainers,
      },
    });
  };

  return (
    <div className="space-y-4">
      <ContainerList
        containers={containers}
        completeContainers={completeContainers}
        handleCheckboxChange={handleCheckboxChange}
      />
    </div>
  );
};
